import { type FC, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useHeaderActionsContainer } from '@/providers/header-actions-provider';

export const HeaderActions: FC<{ children: ReactNode }> = ({ children }) => {
  const container = useHeaderActionsContainer();
  if (!container) return null;
  return createPortal(children, container);
};
